import { CHANGE_POLICY, CANCEL_POLICY, REINSTATE_POLICY } from 'customer/components/policy/policy.queries';

/**
 * Maps a policy-change action to its dedicated preview mutation and GraphQL response key (issue #31365).
 *
 * Cancellation and reinstatement/rescind route to their first-class mutations; every other change
 * (field edits, non-renewals, billing holds) stays on previewPolicyChangePolicy.
 */
export const getPreviewMutationForAction = (action) => {
  if (action === 'cancel') {
    return { mutation: CANCEL_POLICY, previewKey: 'previewPolicyCancellation' };
  }
  if (action === 'reinstate' || action === 'rescind') {
    return { mutation: REINSTATE_POLICY, previewKey: 'previewPolicyReinstatement' };
  }
  return { mutation: CHANGE_POLICY, previewKey: 'previewPolicyChangePolicy' };
};
